export default {
      id: "i-calendar-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "img/sprite.svg#i-calendar",
      toString: function () {
        return this.url;
      }
    }